export default "__VITE_ASSET__BljpO67z__"